import { Injectable } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { PrimeNG } from 'primeng/config';

export type LanguageCode = 'de' | 'en';

@Injectable({ providedIn: 'root' })
export class I18nService {
  private readonly storageKey = 'external_website_language';
  private readonly supportedLanguages: LanguageCode[] = ['de', 'en'];

  constructor(
    private readonly translateService: TranslateService,
    private readonly primeng: PrimeNG
  ) {
    const storedLanguage = this.getStoredLanguage();
    const defaultLanguage: LanguageCode = storedLanguage ?? 'de';

    this.translateService.addLangs(this.supportedLanguages);
    this.translateService.setDefaultLang('de');
    this.translateService.use(defaultLanguage);
    this.applyPrimeNgTranslations(defaultLanguage);
  }

  get currentLanguage(): LanguageCode {
    return (this.translateService.currentLang as LanguageCode) || 'de';
  }

  setLanguage(language: LanguageCode): void {
    if (!this.supportedLanguages.includes(language)) {
      return;
    }

    this.translateService.use(language);
    this.applyPrimeNgTranslations(language);
    localStorage.setItem(this.storageKey, language);
  }

  private applyPrimeNgTranslations(_language: LanguageCode): void {
    this.translateService.get('primeng').subscribe((translations) => {
      if (translations) {
        this.primeng.setTranslation(translations);
      }
    });
  }

  private getStoredLanguage(): LanguageCode | null {
    const storedLanguage = localStorage.getItem(this.storageKey) as LanguageCode | null;
    if (storedLanguage && this.supportedLanguages.includes(storedLanguage)) {
      return storedLanguage;
    }
    return null;
  }
}
